import Users from "../components/Users/Users"


function UsersListPage() {
 return(
    <Users />
 )
    
}

export default UsersListPage